__turbopack_context__.v({
  "button": "button-module__Kop_Aa__button",
  "div": "button-module__Kop_Aa__div",
  "span": "button-module__Kop_Aa__span",
});
